import React from 'react';
import { ArrowDownIcon, ArrowRightIcon } from 'lucide-react';
import { teacherSteps } from '../data/content';
import { Eyebrow, SectionLead, SectionTitle } from './ui/Section';
export function Teachers() {
  return <section className="border-y border-line bg-white px-4 py-12 md:py-14" data-id="element-269" data-mp="hpqkw20whpf7">
      <div className="mx-auto max-w-5xl" data-id="element-270" data-mp="lpsoigq74sx4">
        <Eyebrow data-id="element-271" data-mp="lqtysize1bds">👥 Para entrenadores</Eyebrow>
        <SectionTitle data-id="element-272" data-mp="19g4v9o9pgjm4">
          ¿Sos <span className="text-accent" data-id="element-273" data-mp="19gy6p2jlzxal">profesor de running?</span>
        </SectionTitle>
        <SectionLead data-id="element-274" data-mp="1ef82nfd5r1x9">
          ¿Qué hacés cuando tenés principiantes, corredores de 5K y alumnos preparando 10K o 21K
          dentro del mismo grupo?
        </SectionLead>
        <p className="mx-auto mt-3 max-w-2xl text-center text-base font-black text-ink md:text-lg" data-id="element-275" data-mp="15e1h2rvnj0x5">
          No necesitás improvisar una planificación diferente para cada alumno todas las semanas.
        </p>

        <ol className="mt-8 grid gap-3 md:grid-cols-4" data-id="element-276" data-mp="3q51y50a5jmeu">
          {teacherSteps.map(([number, title, text], index) => <li key={number} className="relative flex flex-col items-center rounded-2xl border border-line bg-canvas p-5 text-center" data-id="element-277" data-mp="2gt4pilmbpy86" data-mpi={index}>
              <span className="flex h-10 w-10 items-center justify-center rounded-full bg-accent text-base font-black text-white" data-id="element-278" data-mp="2qqsndkf87luk">
                {number}
              </span>
              <p className="mt-3 text-sm font-black uppercase tracking-wide text-ink md:text-base" data-id="element-279" data-mp="2zqxurukf6k8q">
                {title}
              </p>
              <p className="mt-1 text-sm font-semibold leading-snug text-slate-600" data-id="element-280" data-mp="2uqtea4jihpii">{text}</p>
              {index < teacherSteps.length - 1 && <>
                  <ArrowRightIcon className="absolute -right-3 top-1/2 hidden h-5 w-5 -translate-y-1/2 text-accent md:block" aria-hidden="true" data-id="element-281" data-mp="34hxsv359z8ct" />
                  <ArrowDownIcon className="absolute -bottom-2.5 left-1/2 h-5 w-5 -translate-x-1/2 text-accent md:hidden" aria-hidden="true" data-id="element-282" data-mp="3egdj73whadl9" />
                </>}
            </li>)}
        </ol>

        <p className="mt-8 text-center text-xs font-bold uppercase tracking-wide text-accent-dark md:text-sm" data-id="element-283" data-mp="3qfs9ckzi9kqr">
          Diseñado para alumnos individuales y grupos con diferentes niveles
        </p>
      </div>
    </section>;
}